module.exports = __webpack_public_path__ + "img/banner_iot.f99f8939.jpg";